import React from "react";
import styled from "styled-components";

const Wrapper = styled.div<{ active: boolean }>`
	position: fixed;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	background-color: rgba(0, 0, 0, 0.5);
	backdrop-filter: blur(8px);
	transition: ${(props) => props.theme.transition.default};

	opacity: ${(props) => (props.active ? 1 : 0)};
	${(props) => (props.active ? props.theme.event.able : props.theme.event.disable)};
	color: white;
	${(props) => props.theme.layout.center_flex};
	z-index: ${(props) => props.theme.zIndex.dim};
`;
const Div = styled.div`
	width: 12px;
	height: 2px;
	background-color: #fff;
`;

const Dim: React.FC<{ active: boolean; className?: string; line?: boolean }> = ({ active, className, line }) => {
	return (
		<Wrapper active={active} className={className}>
			{line && <Div />}
		</Wrapper>
	);
};

export default Dim;
